export var ActionTypes;
(function (ActionTypes) {
    ActionTypes["LOGIN"] = "LOGIN";
    ActionTypes["LOGOUT"] = "LOGOUT";
    ActionTypes["RESET_USER"] = "RESET_USER";
    ActionTypes["REFRESH_TOKEN"] = "REFRESH_TOKEN";
    ActionTypes["GET_VALID_USER"] = "GET_VALID_USER";
})(ActionTypes || (ActionTypes = {}));
